export default "__VITE_ASSET__7OblqETJ__"